<template>
    <span class="wabident-face-selector">
        <v-select v-if="!lock" multiple class="wabident-selector wabident-selector__small" :filterable="true"
            :options="face_options" placeholder="" @input="change" v-model="selected_face"></v-select>
        <div v-else>
            {{ selected_face_text }}
            <i class="fas fa-lock"
                v-b-popover.hover.top="'Edita directamente el tratamiento si quieres cambiar las piezas.'"
                title="LINEA BLOQUEADA"></i>
        </div>
    </span>
</template>

<script>
export default {
    props: ['value', 'lock'],
    data() {
        return {
            selected_face: [],
            face: [
                'MS', 'DT', 'OC', 'IT', 'IC', 'VB', 'PL', 'BC', 'LB', 'LG'
            ]
        }
    },
    computed: {
        selected_face_text() {
            if (!this.selected_face || !this.selected_face.length) {
                return '';
            }
            return '(' + this.selected_face.map((t) => {
                return t;
            }).join(',') + ')';
        },
        face_options() {
            return this.face.map((t) => {
                return {
                    label: String(t),
                    value: t
                }
            });
        }
    },
    methods: {
        change(val) {
            this.$emit('input', val.map((x) => x.value));
        },
    },
    mounted() {
        this.selected_face = this.value;
    }
}
</script>

<style lang="scss">
.wabident-face-selector {
    display: inline-block;
}
</style>